import React from 'react'
import { useHistory } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import Main from './Main'
import Spinner from '../Spinner'
import { ExpiredDocumentsAlert, CateringAgreementAlert } from 'app/alerts'
import ErrorBoundary from 'app/theme/ErrorBoundary'
import HeaderBanner from 'app/theme/HeaderBanner'
import env from 'env'

export default function Layout(props) {
  const history = useHistory()

  return (
    <div className={[props.containerClassName, 'min-h-screen flex flex-col bg-snow']}>
      {env.HEADER_BANNER_ENABLED && (
        <HeaderBanner message={env.HEADER_BANNER_CONTENT} linkUrl={env.HEADER_BANNER_LINK_URL} linkText={env.HEADER_BANNER_LINK_TEXT} />
      )}
      <Header key={history.location.pathname}/>
      {props.isLoading ? (
        <Main>
          <Spinner className="mx-auto mt-10" />
        </Main>
      ) : (
        <>
          <ExpiredDocumentsAlert />
          <CateringAgreementAlert />
          <Main className={props.className}>
            <ErrorBoundary>
              {props.children}
            </ErrorBoundary>
          </Main>
        </>
      )}
      <Footer />
    </div>
  )
}
